import React, { useEffect, useState } from 'react';
import { NormalText, StyledDivider } from '@Src/commons/StyledComponent';
import {
  SaveOutlined,
  FileTextOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import './DocumentSubmission.less';
import { Alert, AutoComplete, Button, Input, Select } from 'antd';
import FetchGSTRModal from './FetchGSTR/FetchGSTRModal';
import './FetchGSTR/FetchGSTRModal.less';
import VerifyOtpModal from './FetchGSTR/VerifyOtpModal';
import COLOR from '@Src/commons/Colors';
import {
  getCompanyIdentifier,
  getCompanyIdentifierId,
  getGSTRReportsStatus,
} from '@Src/components/OrganisationProfile/OrganisationProfileAction';

function GstrReports({ setVerificationPending }) {
  const [fetchGstrModalOpen, setFetchGstrModalOpen] = useState(false);
  const [verifyOtpModalOpen, setVerifyOtpModalOpen] = useState(false);
  const [inputList, setInputList] = useState([
    {
      id: 1,
      gstin: '',
      isDropDown: true,
      enableButton: false,
      isReportSyncing: false,
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [GSTINNumbers, setGSTINNumbers] = useState([]);
  const [requestId, setRequestId] = useState('');
  const [companyPan, setCompanyPan] = useState('');
  const [companyIdentifierId, setCompanyIdentifierId] = useState();
  const [selectedGSTIN, setSelectedGSTIN] = useState('');
  const [tempInput, setTempInput] = useState('');
  const [userName, setUserName] = useState('');
  const [status, setStatus] = useState(false);
  const onSelectGSTIN = (index: number, gstin: string) => {
    const updatedList = [...inputList];
    updatedList[index].gstin = gstin;
    updatedList[index].enableButton = true;
    setInputList(updatedList);
  };
  const { DARK_BLUE, GRAY_9, GRAY_12, COOL_GRAY } = COLOR;
  const addGSTINDiv = () => {
    setInputList([
      ...inputList,
      {
        id: inputList.length + 1,
        isDropDown: false,
        gstin: '',
        enableButton: false,
        isReportSyncing: false,
      },
    ]);
  };

  const onRemoveDropDown = (input) => {
    if (inputList.length > 1) {
      const updatedList = [
        ...inputList.filter((inputItem) => inputItem.id !== input.id),
      ];
      setInputList(updatedList);
    } else {
      setInputList([
        {
          id: 1,
          gstin: '',
          isDropDown: true,
          enableButton: false,
          isReportSyncing: false,
        },
      ]);
    }
    // const updatedItems = GSTINNumbers.concat({ value: input.gstin, text: input.gstin });
    setGSTINNumbers((prev) =>
      prev.concat({ value: input.gstin, text: input.gstin })
    );
  };

  useEffect(() => {
    setLoading(true);
    getCompanyIdentifier()
      .then((res) => {
        setCompanyPan(res?.pan);

        if (res?.gstin) {
          setGSTINNumbers(
            res.gstin.map((item) => ({
              value: item,
              text: item,
            }))
          );
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  const isCompanyGstin = (gstin: string) => {
    const gstinPAN = gstin.substring(2, 12);

    if (gstinPAN === companyPan) {
      return true;
    }
    return false;
  };

  return (
    <div className="gstin-report-wrapper">
      <StyledDivider orientation="left">FINANCIAL DOCUMENTS</StyledDivider>
      <div className="flex ml-4" style={{ color: '${COLOR.DARK_BLUE}' }}>
        <FileTextOutlined className="gstr-icon mr-8 mt-4" />
        <div className="flex-column-direction">
          <NormalText
            fontSize={12}
            fontWeight={700}
            color={COLOR.GRAY_10}
            style={{ textTransform: 'uppercase' }}
          >
            GSTR REPORTS
          </NormalText>
          <NormalText fontSize={12} fontWeight={400} color={COLOR.GRAY_12}>
            Fetch your GSTR Reports in one click below.
          </NormalText>
        </div>
      </div>
      {inputList?.map((inputItem, index) => (
        <>
          {inputItem.gstin === '' ? (
            <div
              className="v-gap-12 ml-24 align-items-center"
              key={inputItem.id}
            >
              <AutoComplete
                placeholder="Select GSTIN"
                className="select-gstin"
                options={GSTINNumbers} // Assuming your GSTINNumbers array has label and value properties
                onChange={(val, option) => {
                  const gstinPattern =
                    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
                  if (gstinPattern.test(val) && isCompanyGstin(val)) {
                    setSelectedGSTIN(val);
                    onSelectGSTIN(index, val);
                  }
                }}
                onSelect={(value, option) => {
                  const selectedGSTIN = GSTINNumbers.find(
                    (item) => item.value === value
                  );
                  setSelectedGSTIN(selectedGSTIN.value);
                  onSelectGSTIN(index, selectedGSTIN.value);
                  const updatedItems = GSTINNumbers.filter(
                    (item) => item.value !== selectedGSTIN.value
                  );
                  setGSTINNumbers(updatedItems);
                }}
                filterOption={(inputValue, option) =>
                  option.value.toUpperCase().includes(inputValue.toUpperCase())
                }
              />
              <SaveOutlined
                className="gstr-icon"
                style={{ color: `${COLOR.COOL_GRAY}` }}
                onClick={() => onSelectGSTIN(index, tempInput)}
              />
            </div>
          ) : (
            <div className="selected-gstin">
              <NormalText
                fontSize={14}
                fontWeight={400}
                style={{ marginLeft: '28px' }}
                color={COLOR.GRAY_9}
              >
                {inputItem.gstin}
                <DeleteOutlined
                  className="gstr-icon ml-12"
                  style={{ color: `${COLOR.GRAY_12}` }}
                  onClick={() => onRemoveDropDown(inputItem)}
                />
              </NormalText>
              <Button
                loading={!!inputItem.isReportSyncing}
                onClick={() => {
                  setFetchGstrModalOpen(true);
                  setUserName('');
                }}
              >
                {inputItem.isReportSyncing ? 'Syncing Report' : 'Get Report'}
              </Button>
            </div>
          )}
        </>
      ))}
      {inputList[0]?.isReportSyncing && (
        <>
          <Alert
            className="gstr-reports-info-ribbon"
            message="Fetching the data could take a few minutes. Incase we are unable to fetch the report, Bizongo will internally try again. "
            type="info"
            closable
            showIcon
            icon={<InfoCircleOutlined />}
          />
          <Button className="add-gstin-button" onClick={() => addGSTINDiv()}>
            + Add GSTIN
          </Button>
        </>
      )}
      {fetchGstrModalOpen && (
        <FetchGSTRModal
          fetchGstrModalOpen={fetchGstrModalOpen}
          setFetchGstrModalOpen={setFetchGstrModalOpen}
          setVerifyOtpModalOpen={setVerifyOtpModalOpen}
          selectedGSTIN={selectedGSTIN}
          setRequestId={setRequestId}
          companyIdentifierId={companyIdentifierId}
          username={userName}
          setUserName={setUserName}
        />
      )}
      {verifyOtpModalOpen && (
        <VerifyOtpModal
          verifyOtpModalOpen={verifyOtpModalOpen}
          setVerifyOtpModalOpen={setVerifyOtpModalOpen}
          gstin={selectedGSTIN}
          requestId={requestId}
          companyIdentifierId={companyIdentifierId}
          setRequestId={setRequestId}
          setInputList={setInputList}
          inputList={inputList}
          username={userName}
          setVerificationPending={setVerificationPending}
        />
      )}
    </div>
  );
}
export default GstrReports;
